export default __webpack_public_path__ + "static/media/natura.d8a71cce.png";